module.exports = __webpack_public_path__ + "img/digital_4.7104b8fe.jpg";